import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-square',
  templateUrl: './button-square.component.html',
})
export class ButtonSquareComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
